<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Заявления</h2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            name="search"
            label="Поиск по ФИО или сумме"
            hide-details
            clearable
            class="mx-5"
          ></v-text-field>
          <v-radio-group v-model="radioGroup" row hide-details>
            <v-radio label="Отправлено"></v-radio>
            <v-radio label="Принято к исполнению"></v-radio>
            <v-radio label="Исполнено"></v-radio>
            <v-radio label="Отклонено"></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>
          <v-btn icon class="mr-3" color="secondary" @click="fetch()"><v-icon>replay</v-icon></v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <template>
          <v-container fluid>
            <v-data-iterator
              :items="filtered"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
              :footer-props="footerProps"
              no-data-text="пусто"
              no-results-text="ничего не найдено"
            >
              <template v-slot:default="props">
                <v-expansion-panels focusable>
                  <v-expansion-panel v-for="item in props.items" :key="item.statementid">
                    <v-expansion-panel-header>
                      <table cellspacing="0" cellpadding="0">
                        <tr>
                          <td width="20%"><a :href="`/#/persons/${item.personid}`" target="_blank">{{ item.fullname }}</a></td>
                          <td width="10%">{{(item.amount/100).toFixed(2)}} руб.</td>
                          <td width="35%">{{ item.title }}</td>
                          <td width="15%">
                            <span v-if="item.status === 'Отправлено'" style="color:blue">{{ item.status }}</span>
                            <span v-if="item.status === 'Принято к исполнению'" style="color:orange">{{ item.status }}</span>
                            <span v-if="item.status === 'Исполнено'" style="color:green">{{ item.status }}</span>
                            <span v-if="item.status === 'Отклонено'" style="color:red">{{ item.status }}</span>
                          </td>
                          <td width="15%"><span>Создано: {{ item.cts.split(' ')[0] }}</span></td>
                          <td width="15%"><span v-if="item.cts">Обновлено: {{ item.uts.split(' ')[0] }}</span></td>
                        </tr>
                      </table>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content
                      v-model="statement"
                    >
                      <v-card flat>
                        <v-card-text>
                          <span id="printableArea" v-html="item.content" class="hide-on-print"></span>
                        </v-card-text>
                        <v-card-actions>
                          <p>
                            <small><strong>created:</strong>
                              {{ item.cts.split('.')[0] }}
                            </small>
                            <br>
                            <small><strong>updated:</strong>
                              {{ item.uts.split('.')[0] }}
                            </small>
                            <br>
                            <small v-if="item.updatedby"><strong>updated by:</strong>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    v-bind="attrs"
                                    v-on="on"
                                  >{{ item.updatedby.slice(0, 30) }}</span>
                                </template>
                                <span>{{ item.updatedby }}</span>
                              </v-tooltip>
                            </small>
                          </p>
                          <v-spacer></v-spacer>
                          <v-select
                            v-if="item.status !== 'Исполнено'  && item.status !== 'Отклонено'"
                            :items="statuses"
                            v-model="item.status"
                            label="Статус"
                            dense
                            hide-details
                            @change="item.unsaved = true"

                          ></v-select>
                          <span v-if="item.status === 'Исполнено' || item.status === 'Отклонено'">ЗАЯВЛЕНИЕ ЗАКРЫТО</span>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="isoperator || isadmin || isbookkeeper && item.unsaved || item.status !== 'Исполнено' && item.status !== 'Отклонено'"
                            :disabled="!item.content"
                            fab
                            @click="updateStatement(item)"
                            class="mx-3"
                          >
                            <v-icon color="primary">save</v-icon>
                          </v-btn>
                            <v-btn
                              :disabled="!item.content"
                              fab
                              @click="print(item)"
                              class="mx-3"
                            >
                              <v-icon color="secondary">print</v-icon>
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                      <v-spacer></v-spacer>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
          </v-data-iterator>
          </v-container>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import pako from 'pako'
import { Base64 } from 'js-base64'
export default {
  name: 'Statements',
  data: () => ({
    radioGroup: 0,
    statements: [],
    filtered: [],
    statement: {},
    statuses: ['Отправлено', 'Принято к исполнению', 'Исполнено', 'Отклонено'],
    statementDataPrint: null,
    filteredStatus: 'processing',
    search: '',
    itemsPerPageArray: [2, 8, 12],
    filter: {},
    page: 1,
    itemsPerPage: 10,
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 10, 20, 50, 100, { text: 'Все', value: -1 } ]
    },
  }),
  methods: {
    async fetch () {
      if (this.isoperator || this.isadmin || this.isbookkeeper) {
        const { statements } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-statements',
          pl: {}
        })
        this.statements = statements
        if (this.radioGroup === 0) {
          this.filtered = this.statements.filter(x => x.status === 'Отправлено')
        } else
        if (this.radioGroup === 1) {
          this.filtered = this.statements.filter(x => x.status === 'Принято к исполнению')
        } else
        if (this.radioGroup === 2) {
          this.filtered = this.statements.filter(x => x.status === 'Исполнено')
        } else
        if (this.radioGroup === 3) {
          this.filtered = this.statements.filter(x => x.status === 'Отклонено')
        }
      }
    },
    print (item) {
      item.content += `
      <br><br><br><br>
      <div>
        <table width="100%" border="1" cellspacing="0" cellpadding="3">
          <tr>
            <td  align="center" colspan="3"><strong>Служебные отметки (заполняются сотрудником)</strong></td>
          </tr>
          <tr>
            <td align="center" width="40%">
              Заявление принял, документы проверил (ФИО сотрудника)
            </td>`
      if (item.statementtype === 'cashlessReturn') {
        item.content += `
          <td align="center" width="20%">
            Сумма к возврату
          </td>
          <td align="center" width="40%">
            Отметка о списании со счета карты (дата, подпись)
          </td>
        `
      } else {
        item.content += `
          <td align="center" width="20%">
            Сумма переноса
          </td>
          <td align="center" width="40%">
            Отметка о переносе (дата, подпись)
          </td>`
          }
      item.content += `
          </tr>
          <tr>
            <td><br><br><br></td>
            <td><br><br><br></td>
            <td><br><br><br></td>
          </tr>
          <tr>
            <td align="center">Комментарии</td>
            <td colspan="2"><br><br></td>
          </tr>
        </table>
      </div>
      `
      this.statementDataPrint = Base64.encode(
        pako.deflate(
          JSON.stringify(item.content)
        )
      )
      window.open(`/#/support/statements/print?data=${this.statementDataPrint}`, '_blank')
    },
    async updateStatement (item) {
      const newStatement = await this.$store.dispatch('sioRequest', {
        topic: 'update-statement',
        pl: {
          status: item.status,
          statementid: item.statementid
        }
      })
      this.fetch()
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isoperator () {
      return this.scopes.includes('operator')
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    isbookkeeper () {
      return this.scopes.includes('bookkeeper')
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    radioGroup (val) {
      this.fetch(val)
    },
    search (val) {
      if (val && this.search !== '') {
        this.filtered = this.statements.filter(x =>
          x.fullname.toLowerCase().includes(this.search.toLowerCase()) ||
          (x.amount / 100).toFixed(2).toString().startsWith(this.search.toLowerCase().replace(',', '.'))
        )
        this.radioGroup === 1 ? this.filtered = this.filtered.filter(x => x.status === 'Отправлено')
          : this.radioGroup === 0 ? this.filtered = this.filtered.filter(x => x.status === 'Принято к исполнению')
            : this.radioGroup === 2 ? this.filtered = this.filtered.filter(x => x.status === 'Исполнено')
              : this.radioGroup === 3 ? this.filtered = this.filtered.filter(x => x.status === 'Отклонено')
                : this.fetch()
      } else {
        this.fetch()
      }
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style>
</style>
